import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.qnatop');
import { OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-qnatop',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.qnatop/view.scss */
/* src/app/component.qnatop/view.scss: no such file or directory */`],
})
export class ComponentQnatopComponent implements OnInit {
  public activeTab: "auto" | "manual" = "auto"; // 기본값: 자동 생성 탭

  constructor(@Inject( Service) public service: Service) { }

  async ngOnInit() {
    await this.service.init();
  }

  public setActiveTab(tab: "auto" | "manual") {
    this.activeTab = tab;
  }
}

export default ComponentQnatopComponent;